import './select.less';

export const selectComponentModule = angular
  .module('Q.components.forms.select', [])

  .directive('select', function () {
    return {
      restrict: 'E',
      require: '?ngModel',
      link: function (scope, elem, attrs, ngModelCtrl) {
        const opts = elem.find('option');
        let once = false;
        if (opts.length && opts.hasClass('placeholder')) {
          elem.on('keyup keydown', () =>
            elem.toggleClass('placeholder', elem[0].value === ''),
          );

          scope.$watch(
            () => elem[0].value,
            (val, oldVal) => {
              if (!once || val !== oldVal) {
                elem.toggleClass('placeholder', val === '');
                once = true;
              }
            },
          );
        }
        if (elem.parent().hasClass('form-control-select')) {
          elem.on('focus', () => {
            elem.parent().addClass('focused');
          });
          elem.on('blur', () => {
            elem.parent().removeClass('focused');
          });
          scope.$watch(
            () => elem.attr('disabled') + elem.attr('readonly'),
            () => {
              elem
                .parent()
                .attr(
                  'disabled',
                  elem.attr('disabled') === undefined ? null : 'disabled',
                );
              elem
                .parent()
                .attr(
                  'readonly',
                  elem.attr('readonly') === undefined ? null : 'readonly',
                );
            },
          );
          if (ngModelCtrl) {
            const toggleInvalidClass = () => {
              elem
                .parent()
                .toggleClass(
                  'ng-invalid-required',
                  !!ngModelCtrl.$error.required,
                );
            };
            ngModelCtrl.$viewChangeListeners.push(toggleInvalidClass);
            // allows us to update the appearance whenever the model value changes without another watch
            ngModelCtrl.$formatters.push((val) => {
              scope.$applyAsync(toggleInvalidClass);
              return val;
            });
            toggleInvalidClass();
          }
        }
      },
    };
  });
